import BackofficeInterceptor from '../BackofficeInterceptor'

const api = new BackofficeInterceptor()

export default {
  addMedico(medico) {
    return api.post('medico', medico)
  },

  getMedicos() {
    return api.get(`/listas/medicos`)
  },
}
